var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibraryAddCheckFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 15.3116L17.95 9.6116L16.9 8.5866L12.275 13.2366L9.85 10.8116L8.8 11.8616L12.25 15.3116ZM6.5 19.8866C6.1 19.8866 5.75 19.7366 5.45 19.4366C5.15 19.1366 5 18.7866 5 18.3866V4.3866C5 3.9866 5.15 3.6366 5.45 3.3366C5.75 3.0366 6.1 2.8866 6.5 2.8866H20.5C20.9 2.8866 21.25 3.0366 21.55 3.3366C21.85 3.6366 22 3.9866 22 4.3866V18.3866C22 18.7866 21.85 19.1366 21.55 19.4366C21.25 19.7366 20.9 19.8866 20.5 19.8866H6.5ZM3.5 22.8866C3.1 22.8866 2.75 22.7366 2.45 22.4366C2.15 22.1366 2 21.7866 2 21.3866V5.8866H3.5V21.3866H19V22.8866H3.5Z",
    fill: "#1C6947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryAddCheckFill);
export default __webpack_public_path__ + "res/media/libraryAddCheckFill.e7c35f5b09fe3efb063aae083e77aa7b.svg";
export { ForwardRef as ReactComponent };